const CHAT_VIEW_STATES = {
  booting: 'STEP_BOOTING',
  category: 'STEP_CATEGORY',
  chat: 'STEP_CHAT',
  connectingToExpert: 'STEP_CONNECTING_TO_EXPERT',
  automation: 'STEP_AUTOMATION',
  email: 'STEP_EMAIL',
  finished: 'STEP_FINISHED',
  name: 'STEP_NAME',
  question: 'STEP_QUESTION',
  rate: 'STEP_RATE',
  rateBad: 'STEP_RATE_BAD',
} as const;

type ChatViewState = (typeof CHAT_VIEW_STATES)[keyof typeof CHAT_VIEW_STATES];

export { CHAT_VIEW_STATES, type ChatViewState };
